// Beneficiários pré-cadastrados do split de pagamento, por empresa.
//
// ATENÇÃO: o backend ainda não tem modelo de múltiplos beneficiários
// (o DataRecipientDto guarda um único recebedor). Até existir um
// endpoint (ex.: GET/PUT /Company/{id}/split-beneficiaries), a lista é
// persistida em localStorage — vale por navegador/máquina.

export interface SplitBeneficiary {
  name: string;
  pixKey: string;
  percent: number; // % do valor do orçamento destinado a este beneficiário
}

const storageKey = (companyId: number) =>
  `dp-split-beneficiaries:${companyId}`;

export function getSplitBeneficiaries(companyId: number): SplitBeneficiary[] {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(storageKey(companyId)) ?? "[]"
    );
    if (Array.isArray(parsed)) {
      return parsed.filter(
        (b) =>
          b &&
          typeof b.name === "string" &&
          typeof b.pixKey === "string" &&
          typeof b.percent === "number"
      );
    }
  } catch {
    // cadastro ausente ou corrompido
  }
  return [];
}

export function saveSplitBeneficiaries(
  companyId: number,
  beneficiaries: SplitBeneficiary[]
): void {
  try {
    localStorage.setItem(
      storageKey(companyId),
      JSON.stringify(beneficiaries)
    );
  } catch {
    // armazenamento cheio — não persiste
  }
}
